/**
 * EmbeddedLink, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/EmbeddedLinkComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

export const EmbeddedLinkCore = {
  type: 'EmbeddedLink',
  name: 'Embedded Link',
  icon: '🔗',
  description: 'Tappable text that opens an external URL.',
  category: 'display',
  maxPerScreen: 2,
  getDefaultProperties() {
    return {
      text: 'Link Text',
      url: 'https://example.com',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      text: {
        type: 'string',
        label: 'Link Text',
        required: true,
      },
      url: {
        type: 'string',
        label: 'URL',
        required: true,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.text || properties.text.trim().length === 0) {
      errors.push('Link text is required');
    }

    if (!properties.url || properties.url.trim().length === 0) {
      errors.push('URL is required');
    }

    // Validate URL format. `URL` does not exist in GraalJS or a bare vm sandbox, where this
    // same code validates generated flows, so the check cannot depend on it.
    if (properties.url) {
      const wellFormed = typeof URL === 'function'
        ? (() => { try { new URL(properties.url); return true; } catch (e) { return false; } })()
        : /^https?:\/\/[^\s/$.?#][^\s]*$/i.test(properties.url.trim());
      if (!wellFormed) {
        errors.push('Invalid URL format');
      }
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    // WhatsApp uses 'on-click-action' for links
    return {
      type: 'EmbeddedLink',
      text: properties.text,
      'on-click-action': {
        name: 'open_url',
        url: properties.url,
      },
    };
  },
  transformFromWhatsApp(whatsappComponent) {
    // Extract URL from on-click-action
    const url =
      whatsappComponent['on-click-action']?.url ||
      whatsappComponent.url ||
      'https://example.com';

    return {
      text: whatsappComponent.text,
      url: url,
      visible: true,
    };
  },
};
